var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/MoneyIcon.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var MoneyIcon = function MoneyIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, "Money Icon"), /*#__PURE__*/React.createElement("path", {
    d: "M25.4825 1.09106C11.969 1.09106 0.965088 12.0667 0.965088 25.5455C0.965088 39.0243 11.969 49.9999 25.4825 49.9999C38.996 49.9999 49.9998 39.0243 49.9998 25.5455C49.9998 12.0667 38.996 1.09106 25.4825 1.09106Z",
    fill: "#F2A619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8739 0C10.6821 0 0 10.6547 0 23.8126C0 36.9705 10.6821 47.6251 23.8739 47.6251C37.0656 47.6251 47.7477 36.9705 47.7477 23.8126C47.7477 10.6547 37.13 0 23.8739 0Z",
    fill: "#FFD237",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1261 35.5584V36.2003C26.1261 37.0988 25.3539 37.8691 24.3886 37.8691C23.4234 37.8691 22.6512 37.0988 22.6512 36.2003V35.4942C19.7554 35.0449 17.6319 33.6329 16.924 31.6431C16.7953 31.3222 16.731 31.0655 16.731 30.8087C16.731 29.9101 17.3745 29.3325 18.3397 29.3325C18.8545 29.3325 19.498 29.4608 20.0128 30.4236C20.6563 31.9641 23.2303 33.1194 25.5469 32.991C27.9279 32.8626 29.3436 31.7073 29.3436 29.9743C29.3436 28.3697 28.314 27.5353 25.5469 26.8934L22.7799 26.2516C18.6615 25.353 16.731 23.5558 16.731 20.6033C16.731 17.5866 18.9832 15.4044 22.5225 14.8267V14.0565C22.5225 13.0937 23.2947 12.3235 24.2599 12.3235C25.2252 12.3235 25.9974 13.0937 25.9974 14.0565V14.6983C29.1505 15.0834 31.4671 16.5597 32.175 18.742C32.3037 19.0629 32.3037 19.3196 32.3037 19.5764C32.3037 20.3466 31.7245 20.8601 30.7593 20.8601C29.9871 20.8601 29.4079 20.5391 29.0218 19.7689C28.314 18.2927 26.0617 17.009 23.8738 17.2657C21.7503 17.4583 20.2702 18.6136 20.2702 20.154C20.2702 21.6303 21.3642 22.5931 23.7451 23.1707L26.5765 23.8126C30.9523 24.7753 32.8185 26.4442 32.8185 29.4608C32.9472 33.5045 29.5366 35.2375 26.1261 35.5584Z",
    fill: "white",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6628 25.0962C5.08365 25.0962 4.56885 24.5827 4.56885 24.0051C4.56885 18.8703 6.56369 14.0564 10.2316 10.3979C13.7065 6.93192 18.3398 4.94219 23.2947 4.74963C23.8739 4.74963 24.3887 5.19893 24.3887 5.77659C24.3887 6.35425 23.9382 6.86774 23.3591 6.86774C18.9833 6.9961 14.8649 8.79328 11.7761 11.8741C8.55855 15.0834 6.75675 19.3838 6.75675 23.9409C6.75675 24.6469 6.3063 25.0962 5.6628 25.0962Z",
    fill: "#F2A619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  }));
};

MoneyIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
MoneyIcon.defaultProps = {
  className: null
};
export default MoneyIcon;